export default {
  en: {
    'messages.components.message-list.from': 'From',
    'messages.components.message-list.participants': 'Participants',
    'messages.components.message-list.subject': 'Subject',
    'messages.components.message-list.sent': 'Sent',
  },
};
